import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import getLandingPage from "../utils/authRedirect";

const OTP_LENGTH = 6;

const VerifyOtp = () => {
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const [timeLeft, setTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);

  const inputsRef = useRef([]);
  const navigate = useNavigate();

  // إدخال الأرقام
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < OTP_LENGTH - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  // الرجوع للخلف
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    try {
      const email = localStorage.getItem("tempEmail");
      const res = await fetch("/api/auth/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp: otp.join("") }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "فشل التحقق");

      if (data.token) localStorage.setItem("token", data.token);

      let user = data.user || null;
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      localStorage.removeItem("tempEmail");

      // التوجيه: لو المستخدم معاه allowedPage محددة من صفحة "المستخدمين"
      // يروح عليها هي بس، غير كده الأدمن يدخل لوحة التحكم وأي مستخدم
      // تاني يدخل شاشة الدعم الافتراضية (نفس منطق Sidebar.jsx)
      navigate(getLandingPage(user));
    } catch (err) {
      alert(err.message || "حدث خطأ");
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(pasteData)) return;

    const digits = pasteData.slice(0, OTP_LENGTH).split("");
    const newOtp = [...otp];

    digits.forEach((digit, index) => {
      newOtp[index] = digit;
    });

    setOtp(newOtp);
    inputsRef.current[Math.min(digits.length - 1, OTP_LENGTH - 1)]?.focus();
  };

  const handleResend = async () => {
    if (!canResend) return;

    try {
      const email = localStorage.getItem("tempEmail");
      const res = await fetch("/api/auth/request-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error();

      setTimeLeft(60);
      setCanResend(false);
      alert("تم إرسال OTP جديد");
    } catch {
      alert("فشل إرسال الكود");
    }
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      setCanResend(true);
      return;
    }
    const timer = setTimeout(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2 className="text-3xl font-bold text-[#263238] mb-2">
        تحققك من بريدك الإلكتروني
      </h2>
      <p className="text-gray-500 text-sm">
        من فضلك ادخل رمز التحقق الذى تم ارساله الى بريدك
      </p>
      <br />
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={digit}
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
            style={{
              width: "50px",
              height: "50px",
              textAlign: "center",
              fontSize: "20px",
              borderRadius: "10px",
              border: digit ? "2px solid #263238" : "2px solid #ccc",
              outline: "none",
            }}
          />
        ))}
      </div>
      <button
        onClick={handleSubmit}
        className="bg-[#546E7A] hover:bg-[#263238] text-white px-8 py-3 rounded-2xl font-bold"
        style={{ marginTop: "20px" }}
      >
        تأكيد
      </button>
      <div style={{ marginTop: "15px" }}>
        {!canResend ? (
          <p style={{ color: "#888" }}>إعادة الإرسال خلال {timeLeft} ثانية</p>
        ) : (
          <button onClick={handleResend} style={{ color: "#4f46e5" }}>
            إعادة إرسال الكود
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyOtp;